<script setup lang="ts">
withDefaults(
  defineProps<{
    steps?: number
    activeStepIndex?: number
  }>(),
  {
    steps: 1,
    activeStepIndex: 0,
  }
)

const emit = defineEmits<{
  (e: 'stepClick', stepIndex: number): void
}>()
</script>

<template>
  <div class="flex justify-start">
    <template v-if="steps > 1">
      <div
        v-for="(_, stepIndex) in steps"
        :key="stepIndex"
        class="w-2 h-2 m-1.5 rounded-full self-center"
        :class="[
          stepIndex === activeStepIndex
            ? 'bg-primary-800'
            : 'bg-neutral-200 cursor-pointer',
        ]"
        :data-test="`welcome-step-${stepIndex}`"
        @click="emit('stepClick', stepIndex)"
      ></div>
    </template>
  </div>
</template>
